<template>
  <div style="width:100%" class="d-flex flex-column flex-grow-1">
    <div class="d-flex align-center py-3">
      <div>
        <div class="display-1" v-if="isArchitect()">Projects</div>
        <div class="display-1" v-if="isDealer()">
          {{ getLoggedUser().user.name }}, Projects
        </div>
        <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isArchitect()"
        depressed
        color="primary"
        class="white--text"
        @click="addModal = true"
        >Add Project</v-btn
      >
    </div>

    <ProjectList
      v-if="!isLoading"
      :project-list="projectList"
      :pagination-obj="pagination"
      :is-loading="isLoading"
      @refresh="loadProjects"
      @paginate="paginateProjects"
    />

    <AddEditProject
      v-if="addModal"
      :dialog="addModal"
      @refresh="loadProjects"
      @close="addModal = false"
    />
  </div>
</template>

<script>
import ProjectList from "@/components/project/ProjectList";
import AddEditProject from "@/components/project/AddEditProject";
import { mapState } from "vuex";
export default {
  components: {
    ProjectList,
    AddEditProject
  },
  computed: {
    ...mapState({
      projects: store => store.project.projects
    }),
    projectList() {
      if (this.isDealer()) {
        return this.dummy.project;
      }
      return this.projects ? this.projects.project : [];
    },
    pagination() {
      if (this.isDealer()) {
        return this.dummy.pagination;
      }
      return this.projects && this.projects.pagination;
    }
  },
  data() {
    return {
      isLoading: false,
      addModal: false,
      dummy: {
        project: [
          {
            name: "Project 12",
            address: {
              address_line_1: "address 1",
              address_line_2: "address 2",
              city: "city",
              state: "AL",
              zip: 90865,
              latitude: 90,
              longitude: 78
            },
            uuid: "62f570ea-5eeb-4770-95ff-24b2057eb1ec",
            owner: "testing@gmail.com",
            created_on: "2022-02-10T12:35:33.102Z",
            selected_architect: {},
            last_updated: "2022-12-22T07:32:45.679Z"
          },
          {
            name: "aspire",
            address: {
              address_line_1: "gfds",
              address_line_2: "dfhg",
              city: "hgjg",
              state: "dsfdsg",
              zip: 23343,
              latitude: 89,
              longitude: 87
            },
            uuid: "ad547ed4-647b-451c-8b0f-8c454debd587",
            owner: "testing@gmail.com",
            created_on: "2022-02-22T08:12:36.708Z",
            selected_architect: {},
            last_updated: "2022-12-22T07:32:45.679Z"
          },
          {
            name: "aspire1",
            address: {
              address_line_1: "gfds",
              address_line_2: "dfhg",
              city: "hgjg",
              state: "dsfdsg",
              zip: 235789,
              latitude: 89,
              longitude: 87
            },
            uuid: "010d0f54-19f9-4c0d-ad05-4c02c85c4881",
            owner: "testing@gmail.com",
            created_on: "2022-02-22T08:19:12.873Z",
            selected_architect: {},
            last_updated: "2022-12-22T07:32:45.680Z"
          },
          {
            name: "Project2",
            address: {
              address_line_1: null,
              address_line_2: null,
              city: null,
              state: null,
              zip: 600023,
              latitude: null,
              longitude: null
            },
            uuid: "c9616ed8-8b13-46eb-90df-6879d288e247",
            owner: "testing@gmail.com",
            created_on: "2022-02-22T11:46:54.686Z",
            selected_architect: {},
            last_updated: "2022-12-22T07:32:45.680Z"
          },
          {
            name: "Wind Load",
            address: {
              address_line_1: "xxxxx",
              address_line_2: "yyyyy",
              city: "zzzzz",
              state: "AS",
              zip: 34567,
              latitude: 56,
              longitude: 90
            },
            uuid: "2ba135ae-5100-41c9-bfdf-0af78a19edf7",
            owner: "testing@gmail.com",
            created_on: "2022-05-30T15:57:17.377Z",
            selected_architect: {},
            last_updated: "2022-12-22T07:32:45.680Z"
          }
        ],
        pagination: {
          total: 5,
          hasPrevPage: false,
          hasNextPage: false,
          nextPage: null,
          prevPage: null,
          page: 1,
          limit: 10,
          totalPages: 1
        }
      },
      breadcrumbs: [
        {
          text: "Login",
          disabled: true,
          href: "/login"
        },
        {
          text: "Projects"
        }
      ]
    };
  },
  created() {
    this.loadProjects();
  },
  methods: {
    async loadProjects(payload = null) {
      this.addModal = false;
      this.isLoading = true;
      let loader = this.$loading.show();
      await this.$store.dispatch("project/getProjects", payload).finally(() => {
        this.isLoading = false;
        loader.hide();
      });
    },
    paginateProjects(value) {
      this.loadProjects({ page: value });
    }
  }
};
</script>

<style>
.heading {
  font-size: 18pt;
  display: block;
}

.modal-lg {
  max-width: 1000px !important;
  width: 1000px !important;
}

.modal-dialog {
  max-width: 1000px !important;
  width: 1000px !important;
}
</style>
